export default "assets/images/logo_white-ef472c1d.png";